module.exports = __webpack_public_path__ + "img/confetti-bomb.bc978fc0.png";